var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap",attrs:{"id":"breadcrumb"}},[_c('div',{staticClass:"inner"},_vm._l((_vm.path),function(item,index){return _c('router-link',{key:index,attrs:{"to":item.url}},[_vm._v(_vm._s(item.label))])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }